import { AgsPickSchema, AgsResultSchema, AgsSpinResponseSchema } from "ags/integration/schema/ags-spin-response-schema";
import { AgsSpinPublicStateSchema } from "ags/integration/schema/ags-spin-response-schema";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { RecordBuilder } from "appworks/server/builders/record-builder";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { GameiomConfigSchema } from "gameiom/schema/gameiom-config-schema";
import { slotModel } from "slotworks/model/slot-model";

export abstract class AgsRecordBuilder implements RecordBuilder {
    public id: string = "AgsRecordBuilder";

    public abstract filter(request: any, response: any): boolean;

    public build(gameplay: Gameplay, request: any, response: any): Record[] {
        const rootSpin = this.getRootAgsRecord(response);
        const multiplier = gameiomModel.isSocial ? 1 : 100;

        gameplay.balance = Math.round(rootSpin.platform.balance * multiplier);

        if (rootSpin.platform.balanceDetails) {
            gameplay.realBalance = Math.round(rootSpin.platform.balanceDetails.real * multiplier);
            gameplay.freeBalance = Math.round(rootSpin.platform.balanceDetails.bonus * multiplier);
        } else {
            gameplay.realBalance = gameplay.balance;
            gameplay.freeBalance = 0;
        }
        return [];
    }

    protected getRootAgsRecord(response: any): AgsSpinResponseSchema {
        return JSON.parse(response.data) as AgsSpinResponseSchema;
    }

    protected getLatestAgsSpin(rootState: AgsSpinPublicStateSchema): AgsResultSchema | AgsPickSchema {
        let latestRecord: AgsResultSchema | AgsPickSchema = rootState.result;

        while (
            "childFeature" in latestRecord &&
            latestRecord.childFeature &&
            latestRecord.childFeature.length > 0
        ) {
            latestRecord = latestRecord.childFeature[latestRecord.childFeature.length - 1];
        }

        return latestRecord;
    }

    protected isFreeBet(config: GameiomConfigSchema): boolean {
        return !!(config.forcedDenomination || config.forcedStake);
    }

    protected setCreditValues(config: GameiomConfigSchema): void {
        const freeBet: boolean = this.isFreeBet(config);

        const bet = slotModel.read().bet;

        bet.creditSizes.values = config.denominations ?? [1];
        bet.creditSizes.defaultValue = config.defaultDenomination ?? 1;
        bet.creditsPerLine.values = config.stakes;
        bet.creditsPerLine.defaultValue = config.defaultStake;
        if(config.winLines != null) {
            bet.winLines.values = config.winLines;
            bet.winLines.defaultValue = config.defaultWinLines;

            if(bet.winLines.currentValue == null) {
                bet.winLines.currentValue = config.defaultWinLines;
            }
        }
        bet.freeBet = freeBet;

        if (freeBet) {
            bet.creditSizes.currentValue = config.forcedDenomination ?? 1;
            bet.creditsPerLine.currentValue = config.forcedStake;
        }

        uiFlags.set(UIFlag.FREE_BETS, freeBet);

        slotModel.write({ bet });
    }
}
